import { memo, type ComponentType } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';

import {
  PlanViewModeChartIcon,
  PlanViewModeChartTableIcon,
  PlanViewModeTableIcon,
} from '../icons/PlanViewModeIcons';
import { PLAN_TEXT, PLAN_TOOLBAR_HEIGHT } from '../planPageRevampUi';

import type { PlanRevampIconProperties } from '../icons/types';
import type { PlanViewMode } from './PlanToolbar';

const VIEW_TABS: Array<{
  key: PlanViewMode;
  label: string;
  Icon: ComponentType<PlanRevampIconProperties>;
}> = [
  { key: 'chart-table', label: 'Chart + Table', Icon: PlanViewModeChartTableIcon },
  { key: 'chart', label: 'Chart', Icon: PlanViewModeChartIcon },
  { key: 'table', label: 'Table', Icon: PlanViewModeTableIcon },
];

interface Properties {
  viewMode: PlanViewMode;
  onChange: (mode: PlanViewMode) => void;
  primaryColor: string;
  textColor: string;
  activeBg: string;
}

const PlanViewModeTabs = ({
  viewMode,
  onChange,
  primaryColor,
  textColor,
  activeBg,
}: Properties) => (
  <Flex alignItems='stretch' h={PLAN_TOOLBAR_HEIGHT} flexShrink={0} overflow='hidden'>
    {VIEW_TABS.map(({ key, label, Icon }) => {
      const isActive = viewMode === key;

      return (
        <Box
          key={key}
          as='button'
          type='button'
          display='flex'
          alignItems='center'
          justifyContent='center'
          gap={2}
          h='100%'
          px={4}
          py={2}
          border='none'
          borderBottom='2px solid'
          borderBottomColor={isActive ? primaryColor : 'transparent'}
          bg={isActive ? activeBg : 'transparent'}
          color={textColor}
          cursor='pointer'
          flexShrink={0}
          transition='background 0.15s ease, border-color 0.15s ease'
          _hover={{ bg: activeBg }}
          onClick={() => onChange(key)}
        >
          <Icon color={textColor} />
          <Text as='span' {...PLAN_TEXT.toolbarTab} color={textColor} whiteSpace='nowrap'>
            {label}
          </Text>
        </Box>
      );
    })}
  </Flex>
);

export default memo(PlanViewModeTabs);
